import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';

import { Observable } from 'rxjs';

import { SettingsService } from "@shared/services/settings.service";

import { NewNavigationService } from "@shared/services/new-navigation.service";

@Injectable({
  providedIn: 'root'
})
export class WelcomeGuard  {

  constructor(
    private settingsService: SettingsService,
    private navigationService: NewNavigationService,) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const skip = this.settingsService.isSkipChooseLoginMethod();
    if (skip) {
      this.navigationService.toLogin();
      return false;
    }

    return true;
  };
}

